module.exports = __webpack_public_path__ + "img/btn_enter_assistant.1d11ff7b.png";